import { ButtonGroup } from '@progress/kendo-react-buttons';
import React from 'react';
import BaseButton, { AddButton } from '../buttons';
import GroupFilter from './GroupFilter';

const OPERATOR_AND = 'and';
const OPERATOR_OR = 'or';

const CustomFilter = ({ fields, value, onChange }) => {
  const defaultGroupFilter = {
    logic: 'and',
    filters: [{ field: fields[0]?.name, operator: fields[0]?.operators[0]?.operator }],
  };
  const handleChange = (event) => {
    const { prevFilter, nextFilter } = event;
    const filters = value.filters.map((x) => (x === prevFilter ? nextFilter : x));
    const changeEvent = {
      filter: { ...value, filters },
      syntheticEvent: event.syntheticEvent,
      nativeEvent: event.nativeEvent,
      target: this,
    };
    onChange.call(undefined, changeEvent);
  };

  const handleAddGroup = (event) => {
    const changeEvent = {
      filter: { ...value, filters: [...(value.filters || []), { ...defaultGroupFilter }] },
      syntheticEvent: event.syntheticEvent,
      nativeEvent: event.nativeEvent,
      target: this,
    };
    onChange.call(undefined, changeEvent);
  };

  const changeLogic = (event, logic) => {
    if (value.logic !== logic) {
      const e = {
        filter: { ...value, logic },
        target: this,
        syntheticEvent: event,
        nativeEvent: event.nativeEvent,
      };

      onChange.call(undefined, e);
    }
  };

  const handleGroupDelete = (event) => {
    const filters = value.filters.filter((f) => f !== event.filter);
    const changeEvent = {
      filter: { ...value, filters },
      syntheticEvent: event.syntheticEvent,
      nativeEvent: event.nativeEvent,
      target: this,
    };
    onChange.call(undefined, changeEvent);
  };

  return (
    <>
      <div className={'k-widget k-filter'}>
        {value.filters.length > 1 && (
          <ButtonGroup>
            <BaseButton
              title='Or'
              togglable
              selected={value.logic === OPERATOR_OR}
              onClick={(e) => changeLogic(e, OPERATOR_OR)}
            />
            <BaseButton
              title='And'
              togglable
              selected={value.logic === OPERATOR_AND}
              onClick={(e) => changeLogic(e, OPERATOR_AND)}
            />
          </ButtonGroup>
        )}
        <ul className='k-filter-lines'>
          {value.filters.map((x, index) => (
            <li key={index} className='k-filter-item' style={{ marginTop: '5px' }}>
              <GroupFilter
                value={x}
                fields={fields}
                onChange={handleChange}
                onRemove={handleGroupDelete}
                deletable={value.filters.length > 1}
                connectToParent={value.filters.length > 1}
              />
            </li>
          ))}
        </ul>
        <div style={{ marginTop: '5px' }}>
          <AddButton title='Add Group' onClick={handleAddGroup} />
        </div>
      </div>
    </>
  );
};

export default CustomFilter;
